(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // Store the original sticky type from Liquid, if it exists
      this.originalStickyType = this.getAttribute('data-sticky-type');

      // Define the breakpoint for desktop (adjust this value if your theme uses a different breakpoint)
      // This should match the `min-width: 990px` in your CSS for header-drawer if you want consistency.
      this.desktopBreakpoint = 990; 

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      // Add event listeners for sticky header behavior
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Listen for media query changes to update sticky state
      window.matchMedia(`(max-width: ${this.desktopBreakpoint - 1}px)`).addEventListener('change', this.handleMediaQueryChange.bind(this));
      window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).addEventListener('change', this.handleMediaQueryChange.bind(this));

      this.setHeaderHeight();
      this.updateStickyState(); // Initial check on page load
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.matchMedia(`(max-width: ${this.desktopBreakpoint - 1}px)`).removeEventListener('change', this.handleMediaQueryChange.bind(this));
      window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).removeEventListener('change', this.handleMediaQueryChange.bind(this));
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // New method to manage the sticky state based on screen width
    updateStickyState() {
      if (window.innerWidth >= this.desktopBreakpoint) {
        // On desktop, ensure header is NOT sticky
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate', 'scrolled-past-header');
        this.removeAttribute('data-sticky-type'); // Remove the data-sticky-type attribute
        this.headerIsAlwaysSticky = false; // Reset the internal flag
      } else {
        // On mobile, re-apply the original sticky type if it was set
        if (this.originalStickyType && this.originalStickyType !== 'none') {
          this.setAttribute('data-sticky-type', this.originalStickyType);
          this.headerIsAlwaysSticky = (this.originalStickyType === 'always' || this.originalStickyType === 'reduce-logo-size');
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          }
        }
      }
    }

    // New method to handle screen width changes
    handleMediaQueryChange() {
      this.updateStickyState();
      this.setHeaderHeight(); // Recalculate header height as elements might re-arrange
    }

    onScroll() {
      // **Crucial change:** Only apply sticky behavior if on mobile
      if (window.innerWidth >= this.desktopBreakpoint) {
        return; // Exit if on desktop, prevent any sticky logic
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // Only hide if sticky is active (i.e., on mobile and not 'none')
      if (this.headerIsAlwaysSticky) return; // This already existed for 'always' type
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      // Only reveal if sticky is active
      if (this.headerIsAlwaysSticky) return; // This already existed for 'always' type
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // Only reset if sticky is active
      if (this.headerIsAlwaysSticky) return; // This already existed for 'always' type
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
